class UndoManager {

    undoList = []
    undoPosition = -1
    options = {
        maxUndos: 50
    }

    constructor(_options = {}) {
        this.options = {
            ...this.options,
            ..._options
        }
    }

    destroy() {
        // Must be called manually! ... if we use this. We probably don't need to.
    }

    async reset() {
        delete this.undoList;
        this.undoList = [];
        this.undoPosition = -1;
    }

    // NOTE: Be very careful running this. Make sure anything you want to use in do/undofunction is stored
    // in a closure. Anything you don't will go off current state instead! Prototypal inheritance is wild, yo.
    async runUndoableStep(doFunction, undoFunction, uniqueKey) {
        while (this.undoList.length > this.options.maxUndos) {
            this.undoList.shift();
            this.undoPosition--;
        }
        if (this.undoPosition !== this.undoList.length - 1) {
            this.undoList = this.undoList.slice(0, this.undoPosition + 1);
            this.undoPosition = this.undoList.length - 1;
        }

        // Duplicate check 
        if (this.undoList.length && this.undoList[this.undoList.length -1].uniqueKey === uniqueKey) {
            return false;
        }

        this.undoList.push({doFunction, undoFunction, uniqueKey});
        this.undoPosition++;
        await doFunction();
        return true;
    }

    async doUndo() {
        if (this.undoPosition >= 0) {
            await this.undoList[this.undoPosition].undoFunction()
            --this.undoPosition;
        }
    }

    async doRedo() {
        if (this.undoPosition < this.undoList.length - 1) {
            ++this.undoPosition
            await this.undoList[this.undoPosition].doFunction()
        }
    }

    // Standard undo function for use from a relevant component. 
    // Could also refactor this to put/remove from window.document
    async onKeyDown(event) {
        if (event.ctrlKey || event.metaKey) {
            if (event.key === "z") {
                await this.doUndo();
            } else if (event.key === "y" || event.key === "Z") {
                await this.doRedo();
            }
        }
    }   
}

export default UndoManager;